import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Html5 = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Html5' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,2 L21,2 L21,18 L12,22 L3,18 L3,2 Z M17,6 L8,6 L8,11 L16,11 L16,16 L12,17.5 L8,16 L8,14' />
  </StyledIcon>
);
